import React from 'react';
import PropTypes from 'prop-types';
import { Modal as BootstrapModal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const Modal = (props) => {
    return (
        <BootstrapModal
            id="modal-wrapper"
            isOpen={props.isOpen}
            toggle={props.toggle}
            className={props.className}>
            <ModalHeader toggle={props.toggle}>{props.headerText}</ModalHeader>
            <ModalBody>
                {props.bodyText}
                {props.bodyText2 ? <p className="pt-2">{props.bodyText2}</p>: null}
            </ModalBody>
            <ModalFooter>
                <Button id="button-yes" color="primary" onClick={props.handleOkClick}>
                    {props.modalBtnText != null ? props.modalBtnText : "Yes"}
                </Button>
                {props.handleCancelClick ? 
                    <Button id="button-no" color="secondary" className="ml-1" onClick={props.handleCancelClick}>
                        {props.modalCancelBtnText != null ? props.modalCancelBtnText : "Cancel"}
                    </Button> : null
                }
                
            </ModalFooter>
        </BootstrapModal>
    );
}

Button.propTypes = {
    isOpen: PropTypes.bool,
    handleOkClick: PropTypes.func,
    handleCancelClick: PropTypes.func,
    headerText: PropTypes.string,
    bodyText: PropTypes.string,
    bodyText2: PropTypes.string,
    modalBtnText: PropTypes.string,
    modalCancelBtnText: PropTypes.string,
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/common/Modal/Modal.js